import { Outlet } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { Phone } from "lucide-react";
import { BUSINESS } from "../lib/api";

export const Layout = () => {
  return (
    <div className="min-h-screen flex flex-col bg-[#f9f9f6]">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />

      {/* Mobile sticky call bar */}
      <a
        href={BUSINESS.phoneHref}
        data-testid="sticky-call-bar"
        className="md:hidden fixed bottom-4 left-4 right-4 z-40 inline-flex items-center justify-center gap-2 rounded-full bg-emerald-500 text-emerald-950 font-bold py-3 shadow-xl shadow-emerald-900/30 hover:bg-emerald-400 transition-colors"
      >
        <Phone className="h-5 w-5" />
        <span className="num">Call {BUSINESS.phone}</span>
      </a>
    </div>
  );
};
